module.exports = __webpack_public_path__ + "img/w3_link_dark.5c711fda.png";